var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGovernance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.529 3a.5.5 0 01.492.41l.008.09v5.188h3.139a.5.5 0 01.47.328l.023.087 1.527 8.804a.5.5 0 01-.41.579l-.083.006H1.2a.5.5 0 01-.5-.502l.007-.083 1.524-8.804a.5.5 0 01.404-.407l.089-.008h3.142V3.5a.5.5 0 01.41-.492L6.366 3h9.163zm3.218 6.688h-2.718v3.645h.755a.5.5 0 01.09.993l-.09.008H5.111a.5.5 0 01-.09-.992l.09-.008.755-.001V9.688H3.144l-1.351 7.804h18.308l-1.354-7.804zM15.028 4H6.865v9.333h8.164L15.028 4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernance);
export default __webpack_public_path__ + "static/media/Governance.7767f5f4.svg";
export { ForwardRef as ReactComponent };